var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('div',{staticClass:"top_container"},[_c('RoomCardList',{attrs:{"search_conditions":_vm.search_conditions}})],1),_c('div',{staticClass:"sp footer",class:{hidden: _vm.footer_is_hidden}},[_c('SearchFooter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }